import Event from '../Event';

export default class RequestFailed extends Event {
    public static type = 'RequestFailed';

    constructor(public readonly status: number) {
        super(RequestFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/core/events/RequestFailed.ts